import { app } from '../../utils/store';

export default class Search {
    constructor() {
        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu'),
        }

        this.search = {
            toggler: document.getElementById('search-toggler'),
            main: document.getElementById('search'),
        }
        this.body = document.querySelector('body');
        app.overlay = document.querySelector('.app-overlay');
    }

    init() {
        this.toggle();
        // if(!Sniff.features.mobile){ this.language(); }
    }

    toggle = () => {
        if (this.search.toggler) {
            this.search.toggler.addEventListener('click', () => {
                this.body.classList.toggle('overflow-hidden');
                this.search.main.classList.toggle('hidden-search');
                app.overlay.classList.toggle('active');
                this.menu.main.classList.toggle('disabled');
                this.menu.toggler.classList.toggle('disabled');
            });
        }

        // if(this.search.main.classList.contains('active')){
        //     this.search.main.classList.remove('active');
        //     app.overlay.classList.remove('active');
        // }
    }
}
